/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExchangeNewProductDto = {
  /**
   * Warehouse inventory product ID
   */
  warehouseInventoryProductId: number;
  /**
   * Original price of the product
   */
  originalPrice: number;
  /**
   * Markup type applied before discount
   */
  markupType: ExchangeNewProductDto.markupType;
  /**
   * Markup value
   */
  markupValue?: number;
  /**
   * Price after markup and before discount
   */
  adjustedPrice?: number;
  /**
   * Discount type
   */
  discountType: ExchangeNewProductDto.discountType;
  /**
   * Discount value
   */
  discountValue?: number;
  /**
   * Final price after markup and discount
   */
  finalPrice: number;
  /**
   * Whether the piece is handed to the customer on confirm (LOCAL only; REMOTE must be false)
   */
  isDelivered?: boolean;
};
export namespace ExchangeNewProductDto {
  /**
   * Markup type applied before discount
   */
  export enum markupType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
  /**
   * Discount type
   */
  export enum discountType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
}
